export default {
  summary: 'Brak uprawnień Keycloak',
  details: 'Aktualny użytkownik nie ma wymaganych ról klienta w Keycloak. Tworzenie nowych użytkowników ani edycja istniejących nie jest możliwa. Przypisz użytkownikowi brakujące role lub skontaktuj się z pomocą techniczną Nitrex w celu uzyskania pomocy',
};
